import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { refreshCart, updatePackage } from '../../../actions/cartActions';
import { fetchMessageDesigns, setMessagePicker } from '../../../actions/cartHelperActions';
import MessageModal from '../../../components/MessageModal/MessageModal';
import { isEqual } from 'lodash';

class MessagePickerContainer extends Component {
    componentDidMount() {
        if (this.props.messagePicker) {
            this.props.fetchMessageDesigns(this.props.country);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            country,
            isCountrySet,
            fetchMessageDesigns,
            messagePicker,
            messageDesigns
        } = this.props;
        if (!isEqual(prevProps.messagePicker, messagePicker) && messageDesigns.length === 0) {
            fetchMessageDesigns(country);
        }
        if (prevProps.country !== country && isCountrySet) {
            fetchMessageDesigns(country);
        }
    }

    handleChange = data => {
        const { currency, cartId, updatePackage, messagePicker } = this.props;
        updatePackage(messagePicker.packageId, data, currency, cartId);
    };

    handleClose = () => {
        const { messagePicker, setMessagePicker } = this.props;
        setMessagePicker(null);

        if (messagePicker.redirect) {
            browserHistory.push(messagePicker.redirect);
        }
    };

    render() {
        const { packages, messageDesigns, currency, messagePicker } = this.props;

        if (!messagePicker) return null;

        const pckg = packages.find(p => p.id === messagePicker.packageId);

        return (
            <MessageModal
                availableMessageDesigns={messageDesigns}
                messageDesign={pckg.messageDesign}
                message={pckg.message}
                image={pckg.messageImage}
                front={pckg.messageFront}
                currency={currency}
                onChange={this.handleChange}
                onClose={this.handleClose}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        cartId: state.cart.id,
        packages: state.cart.packages,
        totalPrice: state.cart.totalPrice,
        country: state.pageSettings.country,
        currency: state.pageSettings.currency,
        isCountrySet: state.pageSettings.isCountrySet,
        messageDesigns: state.cartHelper.messageDesigns,
        messagePicker: state.cartHelper.messagePicker
    };
}

export default connect(
    mapStateToProps,
    { updatePackage, fetchMessageDesigns, refreshCart, setMessagePicker }
)(MessagePickerContainer);
